import React, { useEffect, useRef, useState } from "react";

const speakers = [
  {
    name: "Prof. Akshay Kumar Rathore",
    affiliation: "NUS Singapore",
    image: require('../../images/Prof_Akshay_Rathore.jpeg'),
    
    number: "01",
  },
  {
    name: "Prof. Sachchida Nand Tripathi",
    affiliation: "Dean, Kotak School of Sustainability, IIT Kanpur",
    image: require('../../images/Sachchida_Nand_Tripathi.jpg'),
    
    number: "02",
  },
  {
    name: "Mr. Deepak Gadhia",
    affiliation: "Chairman, Sunrise CSP",
    image: require('../../images/Deepak_Gadhia.png'),
   
    number: "03",
  },
];

const SpeakerCard = ({ speaker, index }) => {
  const [visible, setVisible] = useState(false);
  const [imgError, setImgError] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => setVisible(true), index * 180);
        }
      },
      { threshold: 0.15 }
    );
    if (cardRef.current) observer.observe(cardRef.current);
    return () => observer.disconnect();
  }, [index]);

  const initials = speaker.name
    .split(" ")
    .filter((w) => w.length > 2)
    .slice(0, 2)
    .map((w) => w[0])
    .join("");

  return (
    <div
      ref={cardRef}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(40px)",
        transition: "opacity 0.7s ease, transform 0.7s ease",
        background: "#fff",
        borderRadius: "2px",
        boxShadow: "0 2px 8px rgba(1,13,130,0.07), 0 16px 40px rgba(1,13,130,0.06)",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        border: "1px solid rgba(1,13,130,0.08)",
      }}
    >
      {/* Top accent bar */}
      <div
        style={{
          height: "4px",
          background: "linear-gradient(90deg, #010d82 0%, #4f5ebd 60%, #c8a84b 100%)",
        }}
      />

      {/* Speaker number watermark */}
      <div
        style={{
          position: "absolute",
          top: "12px",
          right: "16px",
          fontSize: "56px",
          fontFamily: "'Georgia', serif",
          fontWeight: "700",
          color: "rgba(1,13,130,0.06)",
          lineHeight: 1,
          pointerEvents: "none",
          userSelect: "none",
        }}
      >
        {speaker.number}
      </div>

      {/* Image area */}
      <div
        style={{
          background: "linear-gradient(145deg, #f0f2fb 0%, #e8eaf7 100%)",
          padding: "40px 32px 28px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            position: "relative",
            display: "inline-block",
          }}
        >
          {/* Decorative ring */}
          <div
            style={{
              position: "absolute",
              inset: "-6px",
              borderRadius: "50%",
              background: "linear-gradient(135deg, #010d82 0%, #c8a84b 50%, #010d82 100%)",
              padding: "3px",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                background: "#f0f2fb",
              }}
            />
          </div>

          {!imgError ? (
            <img
              src={speaker.image}
              alt={speaker.name}
              onError={() => setImgError(true)}
              style={{
                width: "168px",
                height: "168px",
                borderRadius: "50%",
                objectFit: "cover",
                objectPosition: "top center",
                display: "block",
                position: "relative",
                zIndex: 1,
                border: "3px solid #fff",
              }}
            />
          ) : (
            <div
              style={{
                width: "168px",
                height: "168px",
                borderRadius: "50%",
                background: "linear-gradient(135deg, #010d82, #3d4eaa)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "52px",
                fontFamily: "'Georgia', serif",
                fontWeight: "700",
                color: "#fff",
                position: "relative",
                zIndex: 1,
                border: "3px solid #fff",
              }}
            >
              {initials}
            </div>
          )}
        </div>
      </div>

      {/* Text content */}
      <div
        style={{
          padding: "28px 32px 36px",
          textAlign: "center",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "10px",
        }}
      >
       

        <h3
          style={{
            margin: 0,
            fontSize: "20px",
            fontFamily: "'Georgia', serif",
            fontWeight: "700",
            color: "#010d82",
            lineHeight: 1.35,
          }}
        >
          {speaker.name}
        </h3>

        {/* Divider */}
        <div
          style={{
            width: "40px",
            height: "2px",
            background: "linear-gradient(90deg, #010d82, #c8a84b)",
            borderRadius: "2px",
          }}
        />

        <p
          style={{
            margin: 0,
            fontSize: "14px",
            fontFamily: "Palatino, 'Palatino Linotype', Georgia, serif",
            color: "#555",
            lineHeight: 1.6,
            fontStyle: "italic",
          }}
        >
          {speaker.affiliation}
        </p>
      </div>
    </div>
  );
};

export default function KeynoteSpeakers() {
  const [headerVisible, setHeaderVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setHeaderVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      style={{
        minHeight: "60vh",
        background: "linear-gradient(180deg, #f7f8fd 0%, #eef0fa 50%, #f7f8fd 100%)",
        padding: "60px 24px 100px",
        fontFamily: "Georgia, serif",
      }}
    >
      {/* Header Section */}
      <div
        style={{
          maxWidth: "860px",
          margin: "0 auto 64px",
          textAlign: "center",
          opacity: headerVisible ? 1 : 0,
          transform: headerVisible ? "translateY(0)" : "translateY(-20px)",
          transition: "opacity 0.8s ease, transform 0.8s ease",
        }}
      >
        {/* Section label */}
        <div
          style={{
            display: "inline-block",
            fontSize: "11px",
            letterSpacing: "4px",
            textTransform: "uppercase",
            color: "#c8a84b",
            fontWeight: "700",
            marginBottom: "20px",
            fontFamily: "Georgia, serif",
          }}
        >
         
        </div>

        <h2
          style={{
            fontSize: "clamp(28px, 5vw, 44px)",
            fontFamily: "'Georgia', serif",
            fontWeight: "700",
            color: "#010d82",
            margin: "0 0 20px",
            lineHeight: 1.2,
            letterSpacing: "-0.5px",
          }}
        >
          Keynote Speakers
        </h2>

        {/* Decorative divider */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            marginBottom: "20px",
          }}
        >
          <div style={{ flex: 1, maxWidth: "120px", height: "1px", background: "linear-gradient(90deg, transparent, #010d82)" }} />
          <div style={{ width: "8px", height: "8px", background: "#c8a84b", transform: "rotate(45deg)" }} />
          <div style={{ flex: 1, maxWidth: "120px", height: "1px", background: "linear-gradient(90deg, #010d82, transparent)" }} />
        </div>

        <p
          style={{
            fontSize: "16px",
            color: "#555",
            lineHeight: 1.75,
            fontStyle: "italic",
            maxWidth: "560px",
            margin: "0 auto",
          }}
        >
          
        </p>
      </div>

      {/* Cards Grid */}
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "32px",
        }}
      >
        {speakers.map((speaker, index) => (
          <SpeakerCard key={index} speaker={speaker} index={index} />
        ))}
      </div>

      {/* Bottom note */}
      <div
        style={{
          textAlign: "center",
          marginTop: "56px",
          fontSize: "13px",
          color: "#999",
          fontStyle: "italic",
        }}
      >
        * More speakers to be announced soon
      </div>
    </div>
  );
}
